import { getWithAuth } from '../Basic/HttpService';

export const getMenuItems = async () => {
    let res = await getWithAuth(`NavigationMenu/RoleBasedMenu`);
    return res;
};
